import { render } from "./AdminTranslations.vue?vue&type=template&id=643741b2&scoped=true"
import script from "./AdminTranslations.vue?vue&type=script&lang=js"
export * from "./AdminTranslations.vue?vue&type=script&lang=js"

import "./AdminTranslations.vue?vue&type=style&index=0&id=643741b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643741b2"]])

export default __exports__